const topics = [
    {
      title: "10 Times Tables",
      standardNumber: "Math",
      description:
        "Understand how forces (pushes or pulls) affect the motion of an object.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F10timetablesrock2025video.mp4?alt=media&token=144184f7-2005-4dd0-8d88-32ebe44c7179",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F10%20TIME%20TABLES%20ROCK.mp3?alt=media&token=8af500a5-6d9e-445a-9a2d-a87e1fb4d271",
      lyrics: ["10 Times Tables",
        "(chorus)",
"10 times any number,",
"You put a zero after that number, you get it.",
"10 times any number,",
"You put a zero after that number, you get it.",

"(verse1)",
"10x1 is 10",
"You put a zero after the 1, you get 10.",
"10x2 is 20,",
"You put a zero after the 2, you get 20.",

 "(bridge1)",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",

"(verse2)",
"10x4 is 40,",
"You put a zero after the 4, you get 40.",
"10x5 is 50,",
"You put a zero after the 5, you get 50.",

" (bridge2)",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",
"10, 20, 30, 40, 50 60, multiply 10’s, multiply 10’s,",
"70, 80, 90, 100, multiply 10’s, multiply 10’s.",

"© Smart Board Learning, LLC. All rights reserved.",
      ],
      gameImage: "/assets/images/preview/game-sample.png" // put a PNG here
    },
    {
      title: "Our Flag",
      standardNumber: "Social Studies",
      description:
        "Understand how forces (pushes or pulls) affect the motion of an object.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famericanflag2025video.mp4?alt=media&token=756a44ba-d6af-41b4-bd71-bc2db4f1c554",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famericanflag2025song.mp3?alt=media&token=1331c218-f3c0-4069-bee1-01085c9823df",
      lyrics: ["Our Flag",
        "(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 1)",
"With stars and stripes, here we stand.",
"A flag waves proudly, across the land.",
"Through the breeze we see freedom dance.",
"Come one, come all, come take a chance.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 2)",
"Patriotism is in everyone’s heart.",
"A love for our country, a love with a spark.",
"In its colors, find joy and pride.",
"The America's spirit will forever fly.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameImage: "/assets/images/preview/game-sample.png"
    },
    {
      title: "Landforms",
      standardNumber: "Science",
      description:
        "Understand the basic needs of a variety of plants and animals in different ecosystems.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flandforms2025video.mp4?alt=media&token=49584227-47f9-4e71-a18a-fe2aeb01a6ba",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flandforms2025song.mp3?alt=media&token=73a58a38-9970-412c-9327-17c270bcd5e2",
      lyrics: ["Landforms",
        "(chorus)",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",

"(verse)",
"Mountains are very high landforms.,",
"You won’t find other landforms as tall.,",
"A hill is a raised area of land.,",
"A cave is a hole in a hill or a mountain.,",
"Volcanoes have openings at the top,",
"That let out lava—hot, melting rock.,",
"Valleys are low areas between mountains,,",
"Formed by glaciers or rivers over time.,",
"A canyon is a deep valley with steep sides.,",
"Plains are flat lands covered by the sky.,",
"Earth has many beautiful landforms.,",
"Earth has many beautiful landforms.,",

"(chorus)",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameImage: "/assets/images/preview/game-sample.png"
    },
    {
      title: "English Ruler",
      standardNumber: "Math",
      description:
        "Understand how forces (pushes or pulls) affect the motion of an object.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenglishruler2025video.mp4?alt=media&token=3dde94f0-96e9-49ce-ab1e-f6133d4475f9",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenglishruler2025song.mp3?alt=media&token=2d1beb16-9520-4248-aa70-a8c1859e10c4",
      lyrics: ["English Ruler",
        "(chorus)",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",

"(verse)",
"Look on a ruler, you will see numbers.",
"Each number represents an inch, an inch.",
"Now, each number tells how many inches.",
"You measure from beginning to end, end.",

"(chorus)",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",

"(verse)",
"Look on a ruler, you will see notches.",
"Each notch is a different size, size.",
"The notch in the middle is one half.",
"The next notch down a size is one fourth.",
"The next notch down a size is one eight.",
"and the smallest notch is one sixteenth.",

"(chorus)",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",
"Let's make it measure up, let's make it measure, yeah.",
"12 inches makes one foot.",
"Yes, we measure up, yeah.",

"© Smart Board Learning, LLC. All rights reserved.",

      ],
      gameImage: "/assets/images/preview/game-sample.png" // put a PNG here
    },
    {
      title: "As a Native",
      standardNumber: "Social Studies",
      description:
        "Understand how forces (pushes or pulls) affect the motion of an object.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fasanative2025video.mp4?alt=media&token=490a5691-e474-4891-b5fb-0b819bb81d49",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fasanative2025song.mp3?alt=media&token=e47098bc-0ebf-478d-9a5a-2cffe63f2ee5",
      lyrics: ["As a Native",
        "(chorus)",
"As an American Native, we fished for food.",
"As an American Native, lots of crops we grew.",
"As an American Native, we hunted for food.",
"We made clothes from plants and the skins of animals.",

"(verse)",
"The fish and the animals were natural resources.",
"The crops that we grew were natural resources.",
"The people who caught the fish were human resources.",
"and the canoes and bows were capital resources.",

"(chorus)",
"As an American Native, we fished for food.",
"As an American Native, lots of crops we grew.",
"As an American Native, we hunted for food.",
"We made clothes from plants and the skins of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameImage: "/assets/images/preview/game-sample.png"
    },
    {
      title: "Adapt to Survive",
      standardNumber: "Science",
      description:
        "Understand the basic needs of a variety of plants and animals in different ecosystems.",
      video:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fadapttosurvivie2025video.mp4?alt=media&token=d7a55d38-6f01-48b5-842d-37634069c361",
        game:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gamevideos%2Fgamevideo2025.mp4?alt=media&token=a90fc949-79d7-4f30-b5e5-e20480a7a054",
      music:
        "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fadapttosurvive2025song.mp3?alt=media&token=118906ed-f2bd-4a02-ae36-c519e8166ed8",
      lyrics: ["Adapt to Survive",
        "(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"(Verse 1)",
"A plant with thorns keeps danger away,",
"While other plants get eaten, every day.",
"Camouflage helps an animal hide,",
"Safe from danger, it stays alive.",
"Spots or stripes can blend right in,",
"Hiding from predators, so they can win.",
"In a changing world, traits play a role,",
"Helping animals reach their goal.",

"(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"(Verse 2)",
"Cause and effect, it’s easy to see,",
"Traits help some live and set them free.",
"Reproducing stronger, they’ll stay alive,",
"Passing on traits, so life will thrive.",
"So watch the world, it’s clear and true,",
"Survival depends on what they do.",
"Traits that help, they carry on,",
"The cycle of life will keep moving strong!",

"(Chorus)",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"With changes in the world, it’s nature’s way.",
"We adapt to survive, adapt to survive.",
"With changes in the world, every day,",
"We adapt to survive, adapt to survive.",
"Some plants and animals have special traits,",
"To adapt to survive, adapt to survive.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameImage: "/assets/images/preview/game-sample.png"
    }
  ];
  
  export default topics;
  